import React from "react";
import cloneDeep from "lodash/cloneDeep";
import without from "lodash/without";
import { LinkContainer, Icon } from "components/common";
import { Alert, Col, Row, Button } from "components/bootstrap";
import Routes from "routing/Routes";
import { isPermitted } from "util/PermissionsMixin";
import withTelemetry from "logic/telemetry/withTelemetry";
import { getPathnameWithoutId } from "util/URLUtils";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import withLocation from "routing/withLocation";
import AddNotificationForm from "./AddNotificationForm";
import NotificationSettingsForm from "./NotificationSettingsForm";
import NotificationList from "./NotificationList";
import styles from "./NotificationsForm.css";
import commonStyles from "../common/commonStyles.css";
class NotificationsForm extends React.Component {
  constructor(props) {
    super(props);
    this.toggleAddNotificationForm = () => {
      this.props.sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_NOTIFICATIONS.ADD_CLICKED, {
        app_pathname: getPathnameWithoutId(this.props.location.pathname),
        app_section: "event-definition-notifications",
        app_action_value: "add-notification-button"
      });
      const { showAddNotificationForm } = this.state;
      this.setState({ showAddNotificationForm: !showAddNotificationForm });
    };
    this.handleAssignNotification = (nextNotification) => {
      const { onChange, eventDefinition } = this.props;
      const nextNotifications = cloneDeep(eventDefinition.notifications);
      nextNotifications.push({
        notification_id: nextNotification
      });
      onChange("notifications", nextNotifications);
      this.toggleAddNotificationForm();
    };
    this.handleRemoveNotification = (notificationId) => {
      const { onChange, eventDefinition } = this.props;
      const notification = eventDefinition.notifications.find((n) => n.notification_id === notificationId);
      const nextNotifications = without(eventDefinition.notifications, notification);
      onChange("notifications", nextNotifications);
    };
    this.state = {
      showAddNotificationForm: false
    };
  }
  render() {
    const { eventDefinition, notifications, defaults, currentUser, onChange } = this.props;
    const { showAddNotificationForm } = this.state;
    const notificationIds = eventDefinition.notifications.map((n) => n.notification_id);
    const missingPermissions = notificationIds.filter(
      (id) => !isPermitted(currentUser.permissions, `eventnotifications:read:${id}`)
    );
    if (missingPermissions.length > 0) {
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6, lg: 5 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, "Missing Notifications Permissions for: ", /* @__PURE__ */ React.createElement("br", null), " ", missingPermissions.join(", "))));
    }
    if (showAddNotificationForm) {
      return /* @__PURE__ */ React.createElement(
        AddNotificationForm,
        {
          notifications,
          onChange: this.handleAssignNotification,
          onCancel: this.toggleAddNotificationForm,
          hasCreationPermissions: isPermitted(currentUser.permissions, "eventnotifications:create")
        }
      );
    }
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6, lg: 5 }, /* @__PURE__ */ React.createElement("span", { className: styles.manageNotifications }, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.ALERTS.NOTIFICATIONS.LIST, target: "_blank" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", bsSize: "small" }, "Manage Notifications ", /* @__PURE__ */ React.createElement(Icon, { name: "open_in_new" })))), /* @__PURE__ */ React.createElement("h2", { className: commonStyles.title }, "Notifications ", /* @__PURE__ */ React.createElement("small", null, "(optional)")), /* @__PURE__ */ React.createElement("p", null, "Is this Event important enough that requires your attention? Make it an Alert by adding Notifications to it."), /* @__PURE__ */ React.createElement(
      NotificationList,
      {
        eventDefinition,
        notifications,
        onAddNotificationClick: this.toggleAddNotificationForm,
        onRemoveNotificationClick: this.handleRemoveNotification
      }
    ), /* @__PURE__ */ React.createElement(NotificationSettingsForm, { eventDefinition, defaults, onSettingsChange: onChange })));
  }
}
export default withLocation(withTelemetry(NotificationsForm));
